import { render, staticRenderFns } from "./exchange-float.vue?vue&type=template&id=51dcc04b&scoped=true&lang=pug&"
import script from "./exchange-float.vue?vue&type=script&lang=js&"
export * from "./exchange-float.vue?vue&type=script&lang=js&"
import style0 from "./exchange-float.vue?vue&type=style&index=0&id=51dcc04b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dcc04b",
  null
  
)

export default component.exports